<div id="tag-new" class="d-inline-block">
    <div class="border-content d-flex align-items-center">
        <span class="text-new p3-medium mb-0 primary-900">New</span>
    </div>
</div>